import createPersistedReducer from 'redux/lib/createPersistedReducer';
// import mergeByProp from 'shared/lib/mergeByProp';

const initialState = {
  statusPages: [],
  statusPageHttpJobs: {},
};

const persistConfig = {
  key: 'statusPageReducer',
  whitelist: [],
  transforms: [],
};
export default createPersistedReducer(
  initialState,
  {
    GET_STATUS_PAGES_SUCCESS: (state, payload) => ({
      ...state,
      statusPages: payload.data,
    }),
    GET_STATUS_PAGE_HTTP_JOBS_SUCCESS: (state, payload) => {
      const statusPageId = payload.meta.statusPageId;
      return {
        ...state,
        statusPageHttpJobs: {
          ...state.statusPageHttpJobs,
          [statusPageId]: payload.data,
        },
      };
    },
  },
  persistConfig,
);
